export function SimpleGhostButton(props) {
    const { children, onClick, disabled, testId, className } = props;
    const baseClasses = "relative px-10 py-4 bg-transparent border border-primary/70 rounded-sm font-inter text-sm tracking-[0.2em] uppercase text-foreground overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-[0_0_25px_hsl(43_66%_52%_/_0.4)] transition-all duration-300";
    
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            data-testid={testId}
            className={baseClasses + (className ? " " + className : "")}
        >
            <span className="relative z-10">{children}</span>
            <span className="absolute top-0 left-0 w-3 h-3 border-t border-l border-primary/50" />
            <span className="absolute top-0 right-0 w-3 h-3 border-t border-r border-primary/50" />
            <span className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-primary/50" />
            <span className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-primary/50" />
        </button>
    );
}

export function SimpleCircleOption(props) {
    const { icon, label, selected, onClick, testId, size } = props;
    const sizeClass = size === "small" ? "w-16 h-16" : size === "large" ? "w-24 h-24" : "w-20 h-20";
    const iconSize = size === "small" ? "text-lg" : size === "large" ? "text-2xl" : "text-xl";
    const labelSize = size === "small" ? "text-[9px]" : size === "large" ? "text-xs" : "text-[10px]";
    
    const baseClasses = "flex flex-col items-center justify-center gap-1.5 rounded-full border transition-all duration-300";
    const stateClasses = selected 
        ? "border-primary bg-primary/10 shadow-[0_0_20px_hsl(43_66%_52%_/_0.4)]" 
        : "border-muted-foreground/30 bg-transparent hover:border-primary/50 hover:bg-primary/5";
    
    return (
        <button
            onClick={onClick}
            data-testid={testId}
            className={baseClasses + " " + sizeClass + " " + stateClasses}
        >
            <span className={iconSize + " " + (selected ? "grayscale-0" : "grayscale opacity-70")}>{icon}</span>
            <span className={"font-inter tracking-wider uppercase " + labelSize + " " + (selected ? "text-primary" : "text-muted-foreground")}>{label}</span>
        </button>
    );
}
